import React, { useEffect } from 'react';
import { getBrowserStorageItem, setBrowserStorageItem } from '@utils/browserStorage';
import { NavButton } from './styles';
import { BROWSER_STORAGE_KEYS, ANALYTICS_EVENTS } from '@constants';
import { updateAnalytics } from '@services/analytics';
import { usePresentation } from '@context/presentation';
import { createAnalyticsEventBody } from '@utils/analytics';

export const ToggleScript = ({ showScript, setShowScript }) => {
    const { scriptKey } = BROWSER_STORAGE_KEYS;
    const { script } = ANALYTICS_EVENTS;
    const { presentationId } = usePresentation();

    const handleScript = async () => {
        if (showScript === false) {
            await updateAnalytics(createAnalyticsEventBody(presentationId, script));
        }

        setShowScript(!showScript);
        setBrowserStorageItem(scriptKey, !showScript);
    };

    useEffect(() => {
        const savedScriptStatus = getBrowserStorageItem(scriptKey);

        if (savedScriptStatus) {
            setShowScript(savedScriptStatus);
        }
    }, []);

    return (
        <NavButton 
            selected={showScript}
            onClick={handleScript}>
                Script
        </NavButton>
    );
};

export default ToggleScript;
